
function Badge({badgeStatus,badgeText}){
  const status = "ml-2 badge " + badgeStatus + " text-white";
    return(
     <span className={`${status}`}> {badgeText}</span>
  
    );
  
  }
export default Badge;